if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        /* SWV: item already in the cart, block Add to cart only (Buy it now stays usable) */
        if (this.submitButton.classList.contains('swv-in-cart')) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              /* SWV: one of one items, so an add error almost always means it is already in the cart */
              soldOutMessage.textContent = 'Already in your cart';
              this.submitButton.classList.add('swv-in-cart');
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.swvInCart = true;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.swvInCart) { this.swvInCart = false; window.swvMarkForm && window.swvMarkForm(this, true); }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* SWV: show "Already in your cart" on any Add to cart button whose item is already in the cart.
   Uses a class rather than aria-disabled, because Shopify's Buy it now button switches itself off
   whenever the Add to cart button is aria-disabled. */
(function () {
  if (window.swvCartMarker) return;
  window.swvCartMarker = true;
  var LABEL = 'Already in your cart';
  var inCart = {};
  var style = document.createElement('style');
  style.textContent = '.swv-in-cart{opacity:.6;cursor:default}';
  document.head.appendChild(style);

  function markForm(form, on) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled) return;
    var text = btn.querySelector('span');
    var soldOut = btn.querySelector('.sold-out-message');
    if (on) {
      if (btn.classList.contains('swv-in-cart')) return;
      if (text) { if (!btn.dataset.swvLabel) btn.dataset.swvLabel = text.textContent.trim(); text.textContent = LABEL; text.classList.remove('hidden'); }
      if (soldOut) soldOut.classList.add('hidden');
      btn.removeAttribute('aria-disabled');
      btn.classList.add('swv-in-cart');
      form.error = true;
    } else if (btn.classList.contains('swv-in-cart') || (soldOut && !soldOut.classList.contains('hidden'))) {
      if (text) { text.textContent = btn.dataset.swvLabel || (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'; text.classList.remove('hidden'); }
      if (soldOut) soldOut.classList.add('hidden');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('swv-in-cart');
      form.error = false;
    }
  }
  window.swvMarkForm = markForm;

  function apply() {
    document.querySelectorAll('product-form').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      if (!input) return;
      markForm(form, !!inCart[input.value]);
    });
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        inCart = {};
        (cart.items || []).forEach(function (i) { inCart[String(i.variant_id)] = true; });
        apply();
      })
      .catch(function () {});
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(apply, 200); }
  function start() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); });
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
